<template>
  <base-layout hideBackButton="true">
    <!--<ion-list><ion-item router-link="/Impostazioni">prova</ion-item></ion-list>-->

    <ion-grid style="height: 100%" scroll-y="false">
      <ion-row class="ion-align-items-center" style="height: 100%">
        <ion-col>
          <ion-row>
            <ion-col style="text-align: center">
              <span v-html="Anteprima.Inf_binf" style="font-size: 12px"></span>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col style="text-align: center">
              <ion-button color="light" size="large" style="width: 75%" router-link="/Informazioni">{{ $t("Informazioni") }}</ion-button>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col style="text-align: center">
              <br />
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col style="text-align: center">
              <span v-html="Anteprima.Inf_batt" style="font-size: 12px"></span>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col style="text-align: center">
              <ion-button color="light" size="large" style="width: 75%" router-link="/HomePageAttivita"> {{ $t("Attività") }} </ion-button>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col style="text-align: center">
              <br />
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col style="text-align: center">
              <ion-button color="light" size="large" style="width: 75%" router-link="/SegnalazioniHome"> <span v-html="$t('btnSegnalazioni')"/></ion-button>
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>
    </ion-grid>
  </base-layout>
</template>

<script>
import { BaseLayout, IonGrid, IonRow, IonCol, IonButton } from "@ionic/vue";

import { DbParamType } from "../components/shared/DbParamType";
import { CommandExecutionType } from "../components/shared/CommandExecutionType";
import { ParameterDirection } from "../components/shared/ParameterDirection";
import { CommandParam } from "../components/shared/CommandParam";
import { dataBoxCall } from "../components/shared/GlobalCallSP";

export default {
  name: "HomePage",
  components: {
    BaseLayout,
    IonGrid,
    IonRow,
    IonCol,
    IonButton,

    //GlobalCallSP,
  },
  data() {
    return {
      arcSezioni: [],
      Anteprima: {},
    };
  },
  methods: {
    GetAnteprima() {
      let prm = [];
      prm.push(new CommandParam("@Lin_codi", "", DbParamType.Int32, 0, ParameterDirection.Input, this.$Lin_codi));
      prm.push(new CommandParam("@Con_toke", "", DbParamType.AnsiString, 10, ParameterDirection.Input, this.$CON_TOKE));
      prm.push(new CommandParam("@Ind_codi", "", DbParamType.AnsiString, 10, ParameterDirection.Input, this.$IND_CODI));
      dataBoxCall
        .Exec(
          prm,
          "stpF_Anagrafica_IndirizziSysApp01_src",
          true,
          "Errore durante esecuzione procedura!",
          CommandExecutionType.ExecuteQuery,
          false,
          this.$DATABOX_CFG
        )
        .then(function (data) {
          // ngToast.create({
          //   className: 'success',
          //   content: 'Record salvato correttamente !',
          //   dismissOnTimeout: true,
          //   dismissButton: true
          // });
          if (data) {
            //valorizzo dati
            console.log("return normale  data");
          }
        })
        .catch(function () {
          console.log("return normale no data");
        });
    },
    GetPulsanti() {
      const self = this;
      let prm = [];
      // inline
      prm.push(new CommandParam("@Lin_codi", "", DbParamType.Int32, 0, ParameterDirection.Input, this.$LIN_CODI));
      prm.push(new CommandParam("@Con_toke", "", DbParamType.AnsiString, 10, ParameterDirection.Input, this.$CON_TOKE));
      prm.push(new CommandParam("@Ind_codi", "", DbParamType.AnsiString, 10, ParameterDirection.Input, this.$IND_CODI));
      dataBoxCall
        .Exec(prm, "stpF_Anagrafica_Indirizzi_info_Anteprima02_lst", true, "", CommandExecutionType.ExecuteQuery, false, this.$DATABOX_CFG)
        .then(function (data) {
          if (data && data.RecordSet.Table.length > 0) {
            self.Anteprima = data.RecordSet.Table[0];
            self.arcSezioni = data.RecordSet.Table1;
          } else {
            self.arcSezioni = [];
          }
        })
        .catch(function (er) {
          console.log("return normale no data" + er);
        });
    },
  },
  mounted() {
    this.GetPulsanti();
  },
};
</script>
